import React from 'react';
import PropTypes from 'prop-types';

import CloseButton from '../../../formElements/CloseButton';
import StaticField from '../../../formElements/StaticField';

import form from '../../../../commonStyles/formStyles.module.css';
import expand from '../../../../commonStyles/rowExpand.module.css';

const BloodTestRowDetails = ({ row, onClose }) => {
    return (
        <div className={expand.rowDropdown}>
            <form className={form.formWrapper}>
                <div className={form.formSection}>
                    <div className={form.formColumn}>
                        <StaticField
                            id="event"
                            label="Event"
                            content={row.event || ' - '}
                            customClass="info"
                        />
                        <StaticField
                            id="linkedModule"
                            label="Linked Module"
                            content={row.linkedModule || ' - '}
                            customClass="info"
                        />
                    </div>

                    <div className={form.formColumn}>
                        <StaticField
                            id="source"
                            label="Source"
                            content={row.source || ' - '}
                            customClass="info"
                        />
                    </div>
                </div>
            </form>
            <CloseButton id="bloodTestRowDetailButton" onClose={onClose} />
        </div>
    );
};

BloodTestRowDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default BloodTestRowDetails;
